<template>
  <div class="space-y-2 prose dark:prose-invert">
    <p>Your information is used solely for:</p>
    <ul class="list-disc list-inside">
      <li>Creating and maintaining your user account.</li>
      <li>Providing secure access to the website and protected areas.</li>
      <li>Communicating essential information related to your account.</li>
      <li>Improving your on-site experience through saved preferences.</li>
    </ul>
    <p>We do not use your email for marketing or share it with third parties, except where required to provide core functionality (e.g., hosting, authentication services).</p>
  </div>
</template>
